import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CreateAccountDTO  {
    _originalTypeClassName = "zvelton_Backoffice.BO.CreateAccountDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CreateAccountDTO.translate = translateService;
}
this.SubscriptionName = null;
this.Email = null;
this.Name = null;
this.Company = null;
this.Password = null;
this.CreateAccountDTOKey = null;
this._key = this.CreateAccountDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
SubscriptionName:any;
Email:any;
Name:any;
Company:any;
Password:any;
private _CreateAccountDTOKey:any;
get CreateAccountDTOKey(): any {
    return this._CreateAccountDTOKey;
  }
set CreateAccountDTOKey(value: any) {
    this._CreateAccountDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CreateAccountDTOKey == null || $this.CreateAccountDTOKey == 0;
            }


}